module.exports = __WEBPACK_EXTERNAL_MODULE_0__;


//////////////////
// WEBPACK FOOTER
// external {"root":"_","commonjs2":["lodash"],"commonjs":"lodash","amd":"lodash"}
// module id = 0
// module chunks = 0